import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy dashboard URL: /dashboard/placement-tests/:id/enroll
 * Enrollment + payment order is handled on the public placement test page.
 */
export default function PlacementTestEnrollRedirect() {
  const { id } = useParams();
  return <Navigate to={`/placement-tests/${id}`} replace />;
}
